/* eslint-disable @typescript-eslint/no-unsafe-function-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import React, {useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {getOldestDate} from '../../../../../common/utils/functions';
import {initModalData} from '../../../../../data/constants/Assurance/AssuranceVoyage/souscription';
import {
  CategorieVoyage,
  SubmitDevisVoyage,
} from '../../../../../data/types/interface/Assurance/AssuranceVoyage/devis';
import {ModalDataDTO} from '../../../../../data/types/interface/Assurance/AssuranceVoyage/souscription';
import {StackParams} from '../../../../../data/types/navigation';
import {VoyageServices} from '../../../../../services/applicatif/voyages';
import mapDispatchToProps from '../../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../../components/Header/HeaderScreen';
import {itemI} from '../../../../components/Inputs/DatePickerModal/MultiDatePicker';
import {Loader} from '../../../../components/Loader';
import ConfirmationModal from '../../../../components/Modal/ConfirmationModal';
import FormDevisMobile from './FormDevisMobile';
import {Result} from './Result';

dayjs.extend(customParseFormat);
type NavigationProps = StackNavigationProp<StackParams, 'DemanderDevis'>;

export function DemanderDevisAssuranceVoyageScreen() {
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const {params}: any = useRoute();
  const {listCategories: getListCategories, postDevis} = VoyageServices();

  const [isLoading, setLoading] = useState(false);
  const [dataDto, setDataDto] = useState<Partial<SubmitDevisVoyage>>({
    dateDebut: undefined,
    dateFin: undefined,
    listNaissance: [],
    type: [],
    motif: '',
    categoryCode: '',
    destinationCode: '',
    categoryLabel: '',
    destinationLabel: '',
    idCategory: -1,
    idDestination: -1,
    dateNaissance: '',
  });
  const [listCategories, setListCategories] = React.useState<
    Array<CategorieVoyage>
  >([]);

  const [modalData, setModalData] = React.useState<ModalDataDTO>({
    ...initModalData,
  });

  const handleGetListCagegories = async () => {
    setLoading(true);
    try {
      const res: any = await getListCategories();

      if (!res?.isError && res.data && Array.isArray(res.data)) {
        setListCategories(res.data);
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (values: SubmitDevisVoyage) => {
    setLoading(true);

    postDevis(values)
      .then((res: any) => {
        if (!res?.isError && res.data) {
          setDataDto(
            {
              ...values,
              type: [
                ...res?.data.map((element: any) => ({
                  montant: element.montant || '',
                  quoteCode: element.quoteCode || '',
                  type: element.type || '',
                  destination: element.destination,
                })),
              ],
            } || undefined,
          );
        } else {
          setModalData({
            status: true,
            title: 'Erreur',
            content: res.message,
            btn1: 'OK',
            btn2: undefined,
            handleBtn1: () => setModalData({...initModalData}),
            handleBtn2: undefined,
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useFocusEffect(
    React.useCallback(() => {
      if (params) {
        setDataDto(() => ({
          dateDebut: params.dateDebut,
          dateFin: params.dateFin,
          listNaissance: params.listNaissance || [],
          type: [],
          motif: params.motif || '',
          categoryCode: params.category,
          destinationCode: params.destination,
          categoryLabel: '',
          destinationLabel: '',
          idCategory: -1,
          idDestination: -1,
          dateNaissance:
            params.dateNaissance ||
            dayjs(
              getOldestDate(
                ((params.listNaissance ?? []) as itemI[])?.map(n => n.value),
              ),
            ).format('YYYY-MM-DD'),
        }));
      }
      !listCategories.length && handleGetListCagegories();
    }, [params]),
  );

  return (
    <View style={{flex: 1}}>
      <HeaderScreen
        title="Assurance Voyage"
        type="ChangeScreen"
        action={() => {
          if (dataDto && dataDto?.type?.length) {
            setDataDto(prev => ({...prev, type: []}));
          } else {
            goBack();
          }
        }}
        noBreadcrumb={false}
      />
      {modalData.status && (
        <ConfirmationModal
          title={modalData.title}
          content={modalData.content}
          btn1={modalData.btn1}
          btn2={modalData.btn2}
          handleBtn1={modalData.handleBtn1}
          handleBtn2={modalData.handleBtn2}
        />
      )}
      {isLoading ? <Loader /> : null}
      {!isLoading ? (
        dataDto?.type?.length ? (
          <Result
            navigate={navigate}
            datas={dataDto}
            listCategory={listCategories}
            type={'single'}
            onCancel={() => {
              setDataDto(prev => ({...prev, type: []}));
            }}
          />
        ) : (
          <FormDevisMobile
            datas={dataDto as SubmitDevisVoyage}
            setDatas={setDataDto}
            listCategories={listCategories}
            onSave={handleSubmit}
            onCancel={() => goBack()}
          />
        )
      ) : null}
    </View>
  );
}
export const DemanderDevisAssuranceVoyage: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DemanderDevisAssuranceVoyageScreen);
